import { render, staticRenderFns } from "./VersionSelector.vue?vue&type=template&id=63272f41&scoped=true&"
import script from "./VersionSelector.vue?vue&type=script&lang=js&"
export * from "./VersionSelector.vue?vue&type=script&lang=js&"
import style0 from "./VersionSelector.vue?vue&type=style&index=0&id=63272f41&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63272f41",
  null
  
)

component.options.__file = "VersionSelector.vue"
export default component.exports